import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../pages/auth/login';
import Signup from '../pages/auth/signup';
import Home from '../pages/home';
import { useAuthContext } from '../contexts/AuthContext';
import Header from '../components/header';
import Footer from '../components/footer';
import Courses from '../pages/courses';
import Blog from '../pages/blogs/blogId';
import Course from '../pages/courses/courseId';
import Blogs from '../pages/blogs';
import ContactUs from './contactUs';
import Quiz from './quiz';
import AdminBlog from '../pages/dashboard/adminPannel/blog';
import AllUsers from '../pages/dashboard/adminPannel/allUsers';
import AdminQuiz from '../pages/dashboard/adminPannel/quiz';
import AdminCourse from '../pages/dashboard/adminPannel/course';
// import StudentResult from '../pages/dashboard/adminPannel/studentsQuiz';
// import EnrolledCourses from '../pages/dashboard/adminPannel/enrolledCourses';
import Questions from '../pages/dashboard/adminPannel/question';
import PrivateRoutes from './PrivateRoutes';
import PrivateRoutesForAdmin from './PrivateRoutesForAdmin';
import StudentPortal from './dashboard/studentPortal';
import UserRecord from "../pages/dashboard/adminPannel/allUsers/userRecord"

export default function Index() {
    const { isAuth, user } = useAuthContext();

    return (
        <>
            <Header />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                        path="/auth/login"
                        element={!isAuth ? <Login /> : <Navigate to="/dashboard" />}
                    />
                    <Route
                        path="/auth/signup"
                        element={!isAuth ? <Signup /> : <Navigate to="/dashboard" />}
                    />
                    <Route
                        path="/dashboard/*"
                        element={
                            <PrivateRoutes
                                Component={StudentPortal}
                            />
                        }
                    />
                    <Route path="/courses" element={<Courses />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route
                        path="/dashboard/blog"
                        element={<PrivateRoutesForAdmin Component={AdminBlog} />}
                    />
                    <Route
                        path="/dashboard/course"
                        element={<PrivateRoutesForAdmin Component={AdminCourse} />}
                    />
                    <Route
                        path="/dashboard/quiz"
                        element={<PrivateRoutesForAdmin Component={AdminQuiz} />}
                    />
                    <Route
                        path="/dashboard/allUser"
                        element={<PrivateRoutesForAdmin Component={AllUsers} />}
                    />
                    <Route
                        path="/dashboard/allUser/:userId"
                        element={<PrivateRoutesForAdmin Component={UserRecord} />}
                    />
                    {/* <Route
                        path="/dashboard/studentsresult"
                        element={<PrivateRoutesForAdmin Component={StudentResult} />}
                    /> */}
                    <Route
                        path="/dashboard/question"
                        element={<PrivateRoutesForAdmin Component={Questions} />}
                    />
                    {/* <Route
                        path="/dashboard/enrolledcourses"
                        element={<PrivateRoutesForAdmin Component={EnrolledCourses} />}
                    /> */}

                    <Route path="/blogs/:blogId" element={<Blog />} />
                    <Route path="/courses/:courseId" element={<Course />} />
                    <Route path="/contactUs" element={<ContactUs />} />
                </Routes>
            </main>
            <Footer />
        </>
    );
}

